import { IDisplayableItem } from 'src/app/models/interfaces/displayable-item.interface';

export class ItemAccess<T extends IDisplayableItem> {
    public constructor(
        public item: T,
        public defaultState: boolean,
        public inherited: boolean,
        public accessId: number = null
    ) {}

    public Clone(): ItemAccess<T> {
        let clone = new ItemAccess(this.item, this.defaultState, this.inherited, this.accessId);
        return clone;
    }
}
